<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-chart-line"></i> Relatórios - Campanha</h3>
      </div>
    </div>
    <Tables ref="tableGrid"
            :columns="columns"
            :showSearch="true"
            :showReload="false"
            :showTipFooter="false"
            v-on:Search="onShowSearch"
            v-on:Load="onLoad"
            v-on:Reload="onLoad">
      <template slot="table-header-buttons">
        <a href="javascript:void(0);" v-b-tooltip.hover :title="'Exportar'" @click="onExportExcel">
          <i class="fas fa-file-excel text-third" style="font-size: 15px"></i>
        </a>
      </template>
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <template>
          <TableColumn  :IsText="true"  :status="1" :value="obj.campanha ? obj.campanha : 'NÃO POSSUI'" />
          <TableColumn  :IsDateOnly="true"  :status="1" :value="obj.dataCriacao" />
          <TableColumn  :IsDateOnly="true"  :status="1" :value="obj.dataEnvio" />
          <TableColumn  :IsText="true"  :status="1" :value="obj.canal ? obj.canal : 'NÃO POSSUI'" />
          <TableColumn  :IsText="true"  :status="1" :value="obj.modelo ? obj.modelo : 'NÃO POSSUI'" />
          <TableColumn  :IsText="true"  :status="1" :value="obj.lista ? obj.lista : 'NÃO POSSUI'" />
          <TableColumn  :IsText="true"  :status="1" :value="obj.situacao ? obj.situacao : '-'" />
          <TableColumn  :IsText="true"  :status="1" :value="obj.enviados ? obj.enviados.toString() : '0'" />
          <TableColumn  :IsText="true"  :status="1" :value="obj.falhas ? obj.falhas : '0'" />
          <TableColumn  :IsText="true"  :status="1" :value="obj.totalContato ? obj.totalContato : '0'" />
          <TableColumn  :IsText="true"  :status="1" :value="obj.totalEnviado ? obj.totalEnviado : '0'" />
          <TableColumn  :IsText="true"  :status="1" :value="obj.totalVisualizado ? obj.totalVisualizado : '0'" />
          <TableColumn  :IsText="true"  :status="1" :value="obj.totalConvertido ? obj.totalConvertido : '0'" />
        </template>
      </tr>
    </Tables>
    <ModalCard ref="ModalCard" v-if="selectedCard" :boardColumns="[]" @hideModal="closeCard" :key="selectedCard"
               :cardId="selectedCard" />
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import { loading } from '@/shared/utils/UIHelper'
import ReportCampanhaGeralRepository from '@/shared/http/repositories/reports/reportCampanha.js'
import ModalCard from '@/views/private/crm/components/modalCard/modalCard.vue'
import SearchScreen from '@/views/private/reports/campanha/campanhaGeral/search/search.vue'

export default {
  name: 'ReportCampanha',
  mixins: [ActionsForm],
  data () {
    return {
      data: null,
      form: null,
      filters: null,
      columns: ['CAMPANHA',
        'DATA DA CRIAÇÃO',
        'DATA ENVIO',
        'CANAL',
        'MODELO',
        'LISTA',
        'SITUAÇÃO',
        'ENVIADOS',
        'NÃO ENVIADOS',
        'TOTAL DE CONTATOS',
        'QUANTIDADE ENVIADOS',
        'VISUALIZAÇÕES',
        'CONVERTIDO'],
      columnsOpt: [
        {value: true, label: 'CAMPANHA'},
        {value: true, label: 'DATA DA CRIAÇÃO'},
        {value: true, label: 'DATA ENVIO'},
        {value: true, label: 'CANAL'},
        {value: true, label: 'MODELO'},
        {value: false, label: 'LISTA'},
        {value: false, label: 'SITUAÇÃO'},
        {value: false, label: 'ENVIADOS'},
        {value: false, label: 'NÃO ENVIADOS'},
        {value: false, label: 'TOTAL DE CONTATOS'},
        {value: false, label: 'QUANTIDADE ENVIADOS'},
        {value: false, label: 'VISUALIZAÇÕES'},
        {value: false, label: 'CONVERTIDO'}
      ],
      selectedCard: null
    }
  },
  components: {
    ModalCard
  },
  mounted () {
    this.$eventHub.on('Filter', ({ filters }) => {
      this.filters = filters

      if (filters.dataCriacaoInicial) {
        this.filters.dataCriacaoInicial = this.moment(filters.dataCriacaoInicial).format('YYYY-MM-DDT03:00:00.000')
      }
      if (filters.dataCriacaoFinal) {
        this.filters.dataCriacaoFinal = this.moment(filters.dataCriacaoFinal).format('YYYY-MM-DDT03:00:00.000')
      }

      if (filters.dataEnvioInicial) {
        this.filters.dataEnvioInicial = this.moment(filters.dataEnvioInicial).format('YYYY-MM-DDT03:00:00.000')
      }
      if (filters.dataEnvioFinal) {
        this.filters.dataEnvioFinal = this.moment(filters.dataEnvioFinal).format('YYYY-MM-DDT03:00:00.000')
      }

      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    })
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    onLoad () {
      if (this.filters) {
        this.onLoadAll()
      } else {
        this.filters = {
          campanha: null,
          dataCriacaoInicial: null,
          dataCriacaoFinal: null,
          dataEnvioInicial: null,
          dataEnvioFinal: null,
          canal: null,
          modelo: null,
          lista: null,
          situacao: null
        }
        this.onLoadAll()
      }
    },
    onLoadAll () {
      loading.push()
      ReportCampanhaGeralRepository.GetAllCampanhaReport(this.filters, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch(this.onException)
    },
    onExportExcel () {
      loading.push()
      ReportCampanhaGeralRepository.ExportAllCampanhaReport(this.filters)
        .then((response) => {
          loading.close()
          const fileStartName = this.moment().format('YYYYMMDDhhmm')
          const blob = new Blob([this.base64ToArrayBuffer(response.data)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const url = URL.createObjectURL(blob)

          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = fileStartName + '_RelatorioCampanha.xlsx'
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
        })
        .catch(this.onException)
    },
    base64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      var len = binaryString.length
      var bytes = new Uint8Array(len)
      for (var i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },
    onShowSearch () {
      let aside = {
        title: 'Filtros',
        self: this,
        component: SearchScreen
      }
      this.$eventHub.emit('Search', aside)
    },
    setVisibleColumns () {
      this.columns = []
      for (let i = 0; i < this.columnsOpt.length; i++) {
        if (this.columnsOpt[i].value) {
          this.columns.push(this.columnsOpt[i].label)
        }
      }
    },
    openCard (cardId) {
      this.selectedCard = cardId
    },
    closeCard () {
      this.selectedCard = null
    }
  }
}

</script>
<style>
.popover-header {
  background-color: #04a791;
  color: #eceff1
}
</style>



// WEBPACK FOOTER //
// src/views/private/reports/campanha/campanhaGeral/reportCampanha.vue